import { monthsLowerCase } from "../../consts/forecast";
import { formatPrice } from "../../helpers/common";

const monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

const monthsShort = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export const MonthlyBreakdown = ({
    selectedForecastYear,
    forecastProducts,
    profitAndLossMonthlyMetrics,
    adSpendTotals,
    revenueTotals
}) => {
    return (
        <section className="rounded-xl border bg-white p-4">
            <div className="mb-3 flex items-center justify-between">
                <h3 className="text-base font-semibold">
                    Monthly Breakdown
                </h3>
                {/* <span className="text-xs text-gray-500">
                    Last sync: 2025-01-15 10:30 AM
                </span> */}
            </div>
            <div className="flex overflow-x-auto gap-4 pb-2 snap-x snap-mandatory">
                {(monthsLowerCase || []).map((monthKey, idx) => {
                    const monthLabel = monthsLong[idx];
                    const forecastSum = (forecastProducts || []).reduce((sum, p) => sum + Number(p?.monthly_forecast_by_month?.[monthKey] || 0), 0);
                    const actualSum = (forecastProducts || []).reduce((sum, p) => sum + Number(p?.monthly_actuals_by_month?.[monthKey] || 0), 0);
                    const variancePct = forecastSum ? ((Number(actualSum || 0) / Number(forecastSum || 0)) * 100) : null;

                    const cmForecast = (Number(revenueTotals?.[monthKey] || 0) / 1.3) - Number(adSpendTotals?.[monthKey] || 0);
                    const cmActual = Number(profitAndLossMonthlyMetrics?.[monthKey]?.contributionMargin || 0);
                    const cmVariancePct = cmForecast ? ((Number(cmActual || 0) / Number(cmForecast || 0)) * 100) : null;

                    return (
                        <div key={monthKey} className={`snap-start flex-1 shrink-0 rounded-xl border p-4 ${variancePct >= 100 ? "bg-green-50 border-green-200" : "bg-rose-50 border-rose-200"} min-w-[320px]`}>
                            <div className="text-center font-semibold mb-3">
                                {monthLabel} {selectedForecastYear}
                            </div>
                            <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-sm">
                                <div>Forecast:</div>
                                <div className="text-right font-medium">${formatPrice(forecastSum)}</div>
                                <div>Actual:</div>
                                <div className="text-right font-medium">${formatPrice(actualSum)}</div>
                                <div>Variance:</div>
                                <div className="text-right font-semibold">{variancePct != null ? `${(Math.round(variancePct * 10) / 10).toFixed(1)}%` : "—"}</div>
                                <div className="mt-2 col-span-2 h-[1px] bg-black/5" />
                                <div>CM Forecast:</div>
                                <div className="text-right font-medium">${formatPrice(cmForecast)}</div>
                                <div>CM Actual:</div>
                                <div className="text-right font-medium">${formatPrice(cmActual)}</div>
                                <div>Variance:</div>
                                <div className="text-right font-semibold">{cmVariancePct != null ? `${(Math.round(cmVariancePct * 10) / 10).toFixed(1)}%` : "—"}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </section>
    )
}